// Public surface for the marketplace module (secondary market).
//
// Marketplace is a NAMESPACE parent — it has no chrome of its own. It groups
// three sibling sub-modules that together own the secondary-market journey:
//   - browse/    — listings discovery (peer-to-peer fractional tokens)
//   - invest/    — secondary-market BUY flow (placeholder)
//   - sell/      — secondary-market SELL flow (placeholder)
// All three are placeholders today until the secondary endpoints land.
// External consumers go through @modules/marketplace.

import { marketplaceRoutes as browseRoutes } from './browse/marketplaceBrowseRoute'
import { marketplaceInvestRoutes } from './invest/marketplaceInvestRoute'
import { marketplaceSellRoutes } from './sell/marketplaceSellRoute'

export const marketplaceRoutes = [
  ...browseRoutes,
  ...marketplaceInvestRoutes,
  ...marketplaceSellRoutes,
]
